module.exports = __webpack_public_path__ + "static/media/high-none-2.ea5edc6d.png";